var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ambienteAtual == 'development')?_c('div',{staticClass:"ambiente-banner ambiente-desenvolvimento"},[_c('p',[_vm._v("Ambiente de Desenvolvimento")])]):_vm._e(),(_vm.ambienteAtual == 'homologacao')?_c('div',{staticClass:"ambiente-banner ambiente-homologacao"},[_c('p',[_vm._v("Ambiente de Homologação")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }